export default "__VITE_ASSET__DHFlp_Mg__"